/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum GenerateProfitLossReportFilterOptionsSettledStatus {
  Everything = "Everything",
  OnlyIncludeSettled = "OnlyIncludeSettled",
  OnlyIncludeNonSettled = "OnlyIncludeNonSettled",
}

export function instanceOfGenerateProfitLossReportFilterOptionsSettledStatus(
  value: any,
): boolean {
  for (const key in GenerateProfitLossReportFilterOptionsSettledStatus) {
    if (
      Object.prototype.hasOwnProperty.call(
        GenerateProfitLossReportFilterOptionsSettledStatus,
        key,
      )
    ) {
      if (
        GenerateProfitLossReportFilterOptionsSettledStatus[
          key as keyof typeof GenerateProfitLossReportFilterOptionsSettledStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function GenerateProfitLossReportFilterOptionsSettledStatusFromJSON(
  json: any,
): GenerateProfitLossReportFilterOptionsSettledStatus {
  return GenerateProfitLossReportFilterOptionsSettledStatusFromJSONTyped(
    json,
    false,
  );
}

export function GenerateProfitLossReportFilterOptionsSettledStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GenerateProfitLossReportFilterOptionsSettledStatus {
  return json as GenerateProfitLossReportFilterOptionsSettledStatus;
}

export function GenerateProfitLossReportFilterOptionsSettledStatusToJSON(
  value?: GenerateProfitLossReportFilterOptionsSettledStatus | null,
): any {
  return value as any;
}

export function GenerateProfitLossReportFilterOptionsSettledStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): GenerateProfitLossReportFilterOptionsSettledStatus {
  return value as GenerateProfitLossReportFilterOptionsSettledStatus;
}
